// extracted by mini-css-extract-plugin
module.exports = {"wrapperChart":"index_wrapperChart__17_bR"};